import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { TakeawayServices } from '../../services';

/**
 * Generated class for the TpvTicketMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-select-menu',
  templateUrl: 'takeaway-order-select-menu.html',
})
export class TakeawayOrderSelectMenuPage {

  max_menus: any;
  max_combo: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals) {

    this.max_menus = this.globals.checkLimitsByLicense('daily_menu', 'limit');
    this.max_combo = this.globals.checkLimitsByLicense('daily_menu', 'limit_combo');

    if (this.max_menus == -1) {
      this.max_menus = undefined;
    }
    if (this.max_combo == -1) {
      this.max_combo = undefined;
    }
  }

  styleAddon() {
    //get height screen
    var height = window.innerHeight - 75; //70 es la capcalera
    height = height / 2; //Div sections
    height = height - 130; //Div categories

    let styles = {
      'height': height + 'px',
      'width': 100 + '%',
      //'background-image': 'linear-gradient(89deg,#ff7a59,#f2547d)',
      'color': '#fff',
      'border-radius': '5px',
      'font-weight': 'bold',
      'overflow': 'hidden',
      'line-height': height + 'px',
      'text-align': 'center',
    };
    return styles;
  }

  back() {
    this.takeawayServices.cleanVariables();
    this.navCtrl.pop();
  }

  changeCategorie(categorie) {
    this.takeawayServices.selected_tag = 'all';
    this.takeawayServices.section_select = categorie;
  }



  changeSelectTag(tag) {
    this.takeawayServices.sendTagDish(tag);
    this.takeawayServices.selected_tag = tag;
  }
  changeSelectTagProduct(tag) {
    this.takeawayServices.sendTagProduct(tag);
    this.takeawayServices.selected_tag = tag;
  }

  changeSelectMenuSelected(menu) {

    if (menu.style === 'combo') {
      this.takeawayServices.is_combo = true;
    } else {
      this.takeawayServices.is_combo = false;
    }

    this.takeawayServices.section_menu_order = menu.sections[0].name;

    this.takeawayServices.menu_select = menu.UID;
  }

  openModalVersionPro() {
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

}






// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-select/takeaway-order-select-menu/takeaway-order-select-menu.ts